// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindPrimarySkill, TagKindPrimarySkill } from "../schema";
import { serialize_KindPrimarySkill_internal, deserialize_KindPrimarySkill_internal } from "./KindPrimarySkill";

export function serialize_TagKindPrimarySkill_internal(value: TagKindPrimarySkill): unknown {
  return ((value: { discriminator: KindPrimarySkill; id: bigint; kind: KindPrimarySkill }): unknown => {
    return {
      discriminator: ((value: KindPrimarySkill): unknown => {
        return serialize_KindPrimarySkill_internal(value);
      })(value["discriminator"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
      kind: ((value: KindPrimarySkill): unknown => {
        return serialize_KindPrimarySkill_internal(value);
      })(value["kind"]),
    };
  })(value);
}
export function serialize_TagKindPrimarySkill(obj: TagKindPrimarySkill): string {
  return renderJsonWithNumbersAsBigint(serialize_TagKindPrimarySkill_internal(obj));
}
export function deserialize_TagKindPrimarySkill_internal(value: unknown): ParserResult<TagKindPrimarySkill> {
  return ((
    value: unknown,
  ): ParserResult<{
    discriminator: KindPrimarySkill;
    id: bigint;
    kind: KindPrimarySkill;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "discriminator")) {
      return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
    }
    const parsed_discriminator = ((): ParserResult<KindPrimarySkill> => {
      return ((value: unknown): ParserResult<KindPrimarySkill> => {
        return deserialize_KindPrimarySkill_internal(value);
      })(value["discriminator"]);
    })();
    if (!parsed_discriminator.success) {
      return { success: false, reason: parsed_discriminator.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/TagKindPrimarySkill/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<KindPrimarySkill> => {
      return ((value: unknown): ParserResult<KindPrimarySkill> => {
        return deserialize_KindPrimarySkill_internal(value);
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
  })(value);
}
export function deserialize_TagKindPrimarySkill(str: string): ParserResult<TagKindPrimarySkill> {
  return deserialize_TagKindPrimarySkill_internal(parseJsonWithNumbersAsBigint(str));
}
